module.exports = __webpack_public_path__ + "components/snow-conditions/static/watermark-88ce759fffa32e587b260dd539edff86.svg";